module.exports = __webpack_public_path__ + "img/maritime-logo.7dbf9c45.jpg";